export const getTimeRange = (time) => {
  if (time === null || time === '') return 'Live'
  const times = time.replace("'", '.').replace('"', '')
  const m = Number(times)

  if (m <= 15) return "0-15'"
  if (m <= 30) return "0-30'"
  if (m <= 45) return "0-45'"
  if (m <= 60) return "0-60'"
  if (m <= 75) return "0-75'"
  return "0-90'"
}
